import { ReactComponent as ArrowHeadIcon } from "assets/arrow-head.svg";
import { ReactComponent as FacebookIcon } from "assets/facebook.svg";
import { ReactComponent as InstagramIcon } from "assets/instagram.svg";
import { ReactComponent as LineIcon } from "assets/line.svg";
import { ReactComponent as LinkedinIcon } from "assets/linkedin.svg";
import { ReactComponent as MSECEBadge } from "assets/msece.svg";
import { ReactComponent as NigeriaBadge } from "assets/nigeria-badge.svg";
import smartcomply_logo from "assets/smartcomply-white.svg";
import { ReactComponent as XIcon } from "assets/x.svg";
import { ReactComponent as YoutubeIcon } from "assets/youtube.svg";
import { useGetStartedContext } from "context/GetStartedContextProvider";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Footer = () => {
  const { t } = useTranslation("home");
  const { handleModalChange } = useGetStartedContext();

  return (
    <footer className="bg-[#202D66] px-14 pt-14 pb-10 max-md:px-8 max-[520px]:px-4 max-lg:py-10">
      <div className="flex flex-col gap-10 items-center justify-center relative">
        <div className="w-full flex items-start justify-between gap-12 flex-wrap max-md:flex-col pb-10">
          <div className="max-w-80 flex flex-col justify-start items-start gap-5">
            <img
              src={smartcomply_logo}
              alt="smartcomply"
              className="w-[300px] max-md:w-48 max-[500px]:w-32"
            />

            <div className="flex gap-3 items-center justify-start">
              <Link
                to="https://www.facebook.com/smartcomply"
                target="_blank"
                className="shadow-[0px_4px_8px_-1px_#0D0D1205] rounded-full w-6 h-6 flex items-center justify-center"
              >
                <FacebookIcon className="" />
              </Link>
              <Link
                to="https://x.com/smartcomplyapp"
                target="_blank"
                className="shadow-[0px_4px_8px_-1px_#0D0D1205] rounded-full w-6 h-6 flex items-center justify-center"
              >
                <XIcon className="" />
              </Link>
              <Link
                to="https://www.linkedin.com/company/smartcomply-ltd"
                target="_blank"
                className="shadow-[0px_4px_8px_-1px_#0D0D1205] rounded-full w-6 h-6 flex items-center justify-center"
              >
                <LinkedinIcon className="" />
              </Link>
              <Link
                to="https://www.youtube.com/@smartcomply"
                target="_blank"
                className="shadow-[0px_4px_8px_-1px_#0D0D1205] rounded-full w-6 h-6 flex items-center justify-center"
              >
                <YoutubeIcon className="" />
              </Link>
              <Link
                to="https://www.instagram.com/smartcomply/"
                target="_blank"
                className="shadow-[0px_4px_8px_-1px_#0D0D1205] rounded-full w-6 h-6 flex items-center justify-center"
              >
                <InstagramIcon className="" />
              </Link>
            </div>

            <div className="">
              <div className="space-y-5">
                <div className="space-y-3">
                  <Link href="mailto:adhere@smartcomply.com">
                    <p className="text-[#FFFFFFB2] text-basetext-end">
                      info@smartcomply.com
                    </p>
                  </Link>
                  <div className="flex gap-1 flex-wrap text-[#FFFFFFB2] text-base text-cend">
                    <span>+234 813 326 2024,</span>{" "}
                    <span>+234 818 371 4383</span>
                  </div>
                </div>
              </div>
            </div>
            <p className="tetx-base text-[#FFFFFFB2] font-normal">
              © 2025 Smartcomply. All rights reserved.
            </p>
          </div>
          <div className="flex items-start justify-between gap-20 max-md:gap-8 flex-wrap max-sm:flex-col text-[#F6F8FA]">
            <ul className="flex flex-col gap-2">
              <li className="font-bold text-sm text-[#FFFFFF] border-b border-white w-fit mb-1.5 capitalize">
                {t("navbar.products")}
              </li>

              <li className="text-sm text-[#FFFFFFB2] font-normal">
                <Link target="_blank" to="https://secure.smartcomply.com">
                  Seequre
                </Link>
              </li>
              <li className="text-sm text-[#FFFFFFB2] font-normal">
                <Link target="_blank" to="https://adhere.smartcomply.com/">
                  Adhere
                </Link>
              </li>

              <li className="text-sm text-[#FFFFFFB2] font-normal">
                <Link target="_blank" to="https://oculusintel.xyz/">
                  Oculus
                </Link>
              </li>
              <li className="text-sm text-[#FFFFFFB2] font-normal">
                <Link target="_blank" to="https://academy.smartcomply.com/">
                  Academy
                </Link>
              </li>
            </ul>
            <ul className="flex flex-col gap-2">
              <li className="font-bold capitalize text-sm text-[#FFFFFF] border-b border-white w-fit mb-1.5">
                {t("footer.company")}
              </li>
              <li className="text-sm capitalize text-[#FFFFFFB2] font-normal">
                <Link to="/about-us">{t("footer.links.about")}</Link>
              </li>
              <li className="text-sm capitalize text-[#FFFFFFB2] font-normal">
                <a href="/about-us#careers">{t("footer.links.careers")}</a>
              </li>
              <li className="text-sm capitalize text-[#FFFFFFB2] font-normal">
                <a href="/blog">{t("footer.links.blog")}</a>
              </li>
            </ul>
            <ul className="flex flex-col gap-2">
              <li className="font-bold capitalize text-sm text-[#FFFFFF] border-b border-white w-fit mb-1.5">
                {t("footer.legal.title")}
              </li>
              {/* <li className="text-sm">FAQ</li> */}
              <li className="text-sm text-[#FFFFFFB2] font-normal">
                <Link to="/terms">{t("footer.legal.links.terms")}</Link>
              </li>
              <li className="text-sm text-[#FFFFFFB2] font-normal">
                <Link to="/privacy-policy">
                  {t("footer.legal.links.privacy")}
                </Link>
              </li>
              <li className="text-sm text-[#FFFFFFB2] font-normal">
                <Link to="/terms">{t("footer.legal.links.refund")}</Link>
              </li>
              <li className="text-sm text-[#FFFFFFB2] font-normal">
                <Link to="/cookie-notice">
                  {t("footer.legal.links.cookies")}
                </Link>
              </li>
            </ul>
          </div>
          <div className="space-y-3">
            <p className="text-white text-xl font-normal">Registered With</p>
            <div className="flex justify-start items-center gap-6">
              <NigeriaBadge className="" />
              <MSECEBadge className="" />
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-[4rem]">
          <div className="space-y-2">
            <h6 className="text-white text-base font-normal border-b border-white w-fit">
              Nigeria
            </h6>
            <p className="text-[#FFFFFFB2] text-base font-light leading-[32px]">
              The Bunker Building 279 Herbert Macaulay Way Yaba Lagos, Nigeria.
            </p>
          </div>
          <div className="space-y-2">
            <h6 className="text-white text-base font-normal border-b border-white w-fit">
              USA
            </h6>
            <p className="text-[#FFFFFFB2] text-base font-light leading-[32px]">
              252, Little Falls Drive, Wilmington, Newcastle County, Delaware,
              USA
            </p>
          </div>
          <div className="space-y-2">
            <h6 className="text-white text-base font-normal border-b border-white w-fit">
              Canada
            </h6>
            <p className="text-[#FFFFFFB2] text-base font-light leading-[32px]">
              41 Grand court Drive Ottawa Canada
            </p>
          </div>
          <div className="space-y-2">
            <h6 className="text-white text-base font-normal border-b border-white w-fit">
              Kenya
            </h6>
            <p className="text-[#FFFFFFB2] text-base font-light leading-[32px]">
              Divine Office Suites Adjacent to ACK St.Mark&apos;s Waiyaki Way,
              Westlands. Nairobi,Kenya
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
